export function requiredError(input, validator) {
  if (
    input == "" ||
    input == null ||
    input == undefined ||
    (typeof input === "object" && Array.isArray(input) && input.length === 0) ||
    (typeof input === "object" && input.length === 0)
  ) {
    if (validator.message) {
      return validator.message;
    }
    return "This field is required";
  }
  return null;
}

export function formatError(input, validator) {
  if (input == "" || input == null || input == undefined) {
    return null;
  }
  let valid = true;
  let error = "";
  let pattern;
  switch (validator.format) {
    case "email":
      valid = String(input)
        .toLowerCase()
        .match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      error = "Enter a valid email";
      break;
    case "phone":
      valid = String(input)
        .toLowerCase()
        .match(/^\d{10}$/);
      error = "Enter a valid phone (10 digit no space)";
      break;
    case "address":
      valid = String(input).match(/^[a-zA-Z0-9\s\-.,/]+$/);
      error = "Enter a valid address";
      break;
    case "url":
      pattern = new RegExp(
        "^(https?://)?" +
          "(?:[a-z\\d](?:[a-z\\d-]*[a-z\\d])?\\.)+[a-z]{2,}|" +
          "(?:\\d{1,3}\\.){3}\\d{1,3}" +
          "(?:\\:\\d{1,5})?" +
          "(?:\\/[\\w\\d%_.~+-]*)*" +
          "(?:\\?[;&\\w\\d%_.~+=-]*)?" +
          "(?:#[-\\w\\d_]*)?$",
        "i"
      );
      valid = !!pattern.test(input);
      error = "Enter a valid URL";
      break;
    case "number-float":
      valid = !isNaN(input);
      error = "Enter a valid number";
      if (validator.limitType == "between") {
        if (input <= validator.left || input >= validator.right) {
          valid = false;
          error = `Enter a valid number between ${validator.left} and ${validator.right}`;
        }
      } else if (validator.limitType == "not-between") {
        if (input > validator.left && input < validator.right) {
          valid = false;
          error = `Enter a valid integer not between ${validator.left} and ${validator.right}`;
        }
      }
      break;
    case "number-int":
      valid = !isNaN(input) && input.toString().indexOf(".") == -1;
      error = "Enter a valid integer";
      if (validator.limitType == "between") {
        if (input <= validator.left || input >= validator.right) {
          valid = false;
          error = `Enter a valid integer between ${validator.left} and ${validator.right}`;
        }
      } else if (validator.limitType == "not-between") {
        if (input > validator.left && input < validator.right) {
          valid = false;
          error = `Enter a valid integer not between ${validator.left} and ${validator.right}`;
        }
      }
      break;
    case "alpha":
      valid = String(input)
        .toLowerCase()
        .match(/^[a-zA-Z]*$/);
      error = "Only alphabets allowed";
      break;
    case "alpha-num":
      valid = String(input)
        .toLowerCase()
        .match(/^[a-zA-Z0-9]*$/);
      error = "Only alphabets & digits allowed";
      break;
    case "alpha-space":
      valid = String(input)
        .toLowerCase()
        .match(/^[a-zA-Z\s]*$/);
      error = "Only alphabets & spaces allowed";
      break;
    case "alpha-num-space":
      valid = String(input)
        .toLowerCase()
        .match(/^[a-zA-Z0-9\s]*$/);
      error = "Only alphabets, digits & spaces allowed";
      break;
    case "regex":
      pattern = new RegExp(validator.regex);
      valid = !!pattern.test(input);
      error = "Invalid input";
      break;
  }
  if (valid) {
    return null;
  } else if (validator.message) {
    return validator.message;
  }
  return error;
}

export function lengthError(input, validator) {
  if (input == "" || input == null || input == undefined) {
    return null;
  }
  if (validator.min <= input.length && input.length <= validator.max) {
    return null;
  }
  if (validator.message) {
    return validator.message;
  }
  return validator.min != validator.max
    ? `This field should be ${validator.min} to ${validator.max} characters`
    : `This field should be exactly ${validator.min} characters`;
}

// This and the length validator are so similar I dont know what to do
export function tickError(input, validator) {
  if (
    input == "" ||
    input == null ||
    input == undefined ||
    (typeof input === "object" && Array.isArray(input) && input.length === 0)
  ) {
    return null;
  }
  if (validator.min <= input.length && input.length <= validator.max) {
    return null;
  }
  if (validator.message) {
    return validator.message;
  }
  if (validator.min === validator.max) {
    return `Must select exactly ${validator.min} options`;
  }
  return `Must select ${validator.min} to ${validator.max} options`;
}

function getExtension(filename) {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
    return "";
  }
  return filename.slice(lastDotIndex + 1).toLowerCase();
}

export function fileTypeError(files, validator) {
  if (!files || files.length === 0) return null;

  const allowedTypes = [...validator.allowedTypes] || [];
  if (validator.allowedTypes.includes("jpeg"))
    if (!allowedTypes.includes("jpg")) allowedTypes.push("jpg");

  const invalidFiles = Array.from(files).filter(
    (file) => !allowedTypes.includes(getExtension(file.name))
  );

  if (invalidFiles.length > 0) {
    return (
      validator.message ||
      `Invalid file type(s). Allowed: ${validator.allowedTypes.join(", ")}`
    );
  }

  return null;
}

export function fileSizeError(files, validator) {
  if (!files || files.length === 0) return null;

  const maxSize = validator.maxSize || 8;
  const invalidFiles = Array.from(files).filter(
    (file) => file.size / 1024 / 1024 > maxSize
  );

  if (invalidFiles.length > 0) {
    return validator.message || `File size must not exceed ${maxSize} MB`;
  }

  return null;
}

export function minDateError(input, validator) {
  if (!input) return null;

  const inputDate = new Date(input);
  const minDate = new Date(validator.value);

  if (isNaN(inputDate.getTime()) || isNaN(minDate.getTime())) {
    return "Invalid date format";
  }

  if (inputDate < minDate) {
    return validator.message || `Date must be on or after ${validator.value}`;
  }

  return null;
}

export function maxDateError(input, validator) {
  if (!input) return null;

  const inputDate = new Date(input);
  const maxDate = new Date(validator.value);

  if (isNaN(inputDate.getTime()) || isNaN(maxDate.getTime())) {
    return "Invalid date format";
  }

  if (inputDate > maxDate) {
    return validator.message || `Date must be on or before ${validator.value}`;
  }

  return null;
}

export default {
  required: requiredError,
  format: formatError,
  length: lengthError,
  tick: tickError,
  fileType: fileTypeError,
  fileSize: fileSizeError,
  minDate: minDateError,
  maxDate: maxDateError,
};
